import { serialize, deserialize, getName } from './tools'
export function getLs(name: string) {
  const _value = (localStorage || window.localStorage).getItem(getName(name))
  if (!_value) return undefined
  return deserialize(_value)
}

export function setLs(name: string, value: any) {
  const _value = serialize(value)
  ;(localStorage || window.localStorage).setItem(getName(name), _value)
}

export function removeLs(name: string) {
  ;(localStorage || window.localStorage).removeItem(getName(name))
}
export function clearLs() {
  ;(localStorage || window.localStorage).clear()
}
